import * as React from "react";
import type { SVGProps } from "react";
const SvgSteps = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path d="M22 4.833c0 .46-.373.834-.833.834H17v4.166a.831.831 0 0 1-.833.834h-3.611v3.61c0 .46-.374.834-.834.834h-3.61v3.611a.831.831 0 0 1-.834.834H2.833a.832.832 0 1 1 0-1.667h3.611v-3.611c0-.459.375-.834.834-.834h3.61v-3.61c0-.459.376-.834.834-.834h3.611V4.833c0-.46.375-.833.834-.833h5c.461 0 .833.373.833.833Z" />
  </svg>
);
export default SvgSteps;
